var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Legacy',{attrs:{"view":"reports","action":"sales"}})}
var staticRenderFns = []

export { render, staticRenderFns }